(function () {
  var coc = {};
  var s = function (k, d) {
    var v = coc?.settings?.[k];
    return v != null ? v : d;
  };
  var sb = function (k, d) {
    var v = coc?.settings?.[k];
    return v != null ? v == 'true' : d;
  };

  function hideCancelModal() {
    if (!coc.cancelling) document.getElementById('coc-cancel-modal')?.remove();
  }

  function checkStatus(n, id) {
    if (n > 5) return;
    fetch('/apps/co/api/order_check?order=' + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(r => {
        if (!r.ok) throw 0;
        return r.json();
      })
      .then(r => {
        if (r.data.cancelled_at != null) {
          if (coc.shop === '6115a9-4f.myshopify.com') {
            let u = new URL(location.href);
            u.searchParams.set('order_cancelled', 'true');
            location.href = u.href;
          } else location.reload();
        } else setTimeout(() => checkStatus(n + 1, id), 1500);
      })
      .catch(e => {
        alert(e?.message || 'Error');
        document.querySelectorAll('.coc-btn-cancel').forEach(b => b.disabled = false);
        coc.cancelling = false;
      });
  }

  function handleCancelOrder(btn, id) {
    if (btn.disabled || id == null) return;
    if (!document.querySelector(".coc-cancel-button[data-order-id='" + id + "']")) return;
    var cbtns = document.querySelectorAll('.coc-btn-cancel');
    document.querySelectorAll('.coc-error').forEach(e => e.classList.remove('coc-err-show'));
    var av = {
      type: s('avail_type', 'until_ship'),
      value: s('avail_val', '1'),
      unit: s('avail_unit', 'days')
    };
    var data = {
      shop: coc.shop,
      order_id: id,
      send_email: sb('send_email', true),
      enable_restock: sb('enable_restock', true),
      enable_refund: sb('enable_refund', true),
      refund_shipping: sb('refund_shipping', true),
      only_cod_cancel: sb('only_cod_cancel', false),
      availability: av,
      restrict_order: sb('restrict_order', false),
      restrict_product: sb('restrict_product', false)
    };
    var sel = document.querySelector('select[name="coc_select_reason"]');
    var txt = document.querySelector('textarea[name="coc_input_reason"]');
    if (sel) {
      if (!sel.value) {
        if (sb('predefined_reason_required', false)) {
          sel.nextElementSibling?.classList.add('coc-err-show');
          return;
        }
      } else data.tag = sel.value;
    }
    if (txt) {
      if (!txt.value) {
        if (sb('reason_required', false)) {
          txt.nextElementSibling?.classList.add('coc-err-show');
          return;
        }
      } else data.reason = txt.value;
    }
    document.querySelector('.coc-modal .coc-not-cod-error')?.remove();
    btn.disabled = true;
    btn.innerHTML = s('cancelling_text', 'Cancelling...');
    cbtns.forEach(b => b.disabled = true);
    coc.cancelling = true;
    fetch('/apps/co/api/order_cancel', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(r => {
        if (!r.ok) throw 0;
        return r.json();
      })
      .then(r => {
        if (r.error) {
          if (['not-cod', 'expired', 'not-allow', 'country-block'].includes(r.error)) {
            btn.disabled = false;
            btn.innerHTML = s('confirm_btn_text', 'Proceed');
            cbtns.forEach(b => b.disabled = false);
            coc.cancelling = false;
            var p = document.createElement('p');
            p.className = 'coc-error coc-err-show coc-not-cod-error';
            p.innerText = r.error == 'not-cod' ? s('not_cod_error', 'This order cannot be cancelled as the chosen payment method is not Cash on Delivery (COD).') :
              r.error == 'expired' ? s('expired_error', 'The order cannot be canceled because it was placed before [value] [unit].').replace(/\[value\]/gi, av.value).replace(/\[unit\]/gi, av.unit) :
              r.error == 'country-block' ? s('location_error', 'Order cancellation is not available for your location.') :
                s('disabled_msg', 'This order cannot be cancelled.');
            document.querySelector('.coc-modal-body')?.appendChild(p);
          } else throw 0;
        } else {
          checkStatus(0, id);
          hideCancelModal();
        }
      })
      .catch(() => {
        hideCancelModal();
        coc.cancelling = false;
        alert('Failed to cancel order');
      });
  }

  function showCancelModal(id) {
    var rl = s('reason_label', 'Reason for Cancellation'),
      re = s('reason_select_error', 'Reason is required.');
    var reasons = s('reasons', '').split(',').filter(r => r != '');
    var rhtml = '',
      chtml = '';
    if (sb('show_reasons', false) && reasons.length) {
      var opts = `<option value=''>${s('reason_placeholder', 'Select reason')}</option>`;
      reasons.forEach(r => {
        var sl = r.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '');
        opts += `<option value="cancel-${sl}">${r}</option>`;
      });
      rhtml = `<div class='coc-input-group'><label class="coc-label" for='coc-r'>${rl}</label><select id='coc-r' name='coc_select_reason'>${opts}</select><p class='coc-error'>${re}</p></div>`;
    }
    if (sb('custom_reason', false)) chtml = `<div class="coc-input-group"><label class="coc-label">${rl}</label><textarea class="coc-input" rows="4" maxlength="200" name="coc_input_reason"></textarea><p class='coc-error'>${re}</p></div>`;
    var m = document.createElement('div');
    m.id = 'coc-cancel-modal';
    m.className = 'coc-modal-outer';
    m.innerHTML = `<div class="coc-modal"><div class="coc-modal-header"><h3 class="coc-modal-header-title">${s('dialog_title', 'Cancel Confirmation')}</h3><button class="coc-close coc-btn-cancel" onclick="coc_hideCancelModal()"><svg viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M13.97 15.03a.75.75 0 1 0 1.06-1.06l-3.97-3.97 3.97-3.97a.75.75 0 0 0-1.06-1.06l-3.97 3.97-3.97-3.97a.75.75 0 0 0-1.06 1.06l3.97 3.97-3.97 3.97a.75.75 0 1 0 1.06 1.06l3.97-3.97 3.97 3.97Z"></path></svg></button></div><div class="coc-modal-body"><p>${s('dialog_msg', 'Are you sure you want to cancel the order?')}</p>${rhtml}${chtml}</div><div class="coc-modal-action"><button class="coc-btn coc-btn-plain coc-btn-cancel" onclick="coc_hideCancelModal()">${s('cancel_btn_text', 'Cancel')}</button><button class="coc-btn" onclick="coc_handleCancelOrder(this,${id})">${s('confirm_btn_text', 'Proceed')}</button></div></div>`;
    document.body.insertBefore(m, document.body.firstChild);
  }

  function mkBtn(cls, id, text, dis) {
    var b = document.createElement('button');
    b.className = 'coc-button ' + cls + ' ' + s('custom_class', '');
    b.setAttribute('data-order-id', id);
    b.innerHTML = text;
    b.style.margin = '0';
    if (dis) b.disabled = true;
    return b;
  }

  function autoAddButton() {
    if (document.querySelector('.coc-cancel-button,.coc-reorder-button')) return;
    var sc = s('show_cancel', 'true') == 'true',
      sr = s('show_reorder', 'true') == 'true';
    if (!sc && !sr) return;
    var ids = Object.keys(coc.orders);
    if (!ids.length) return;
    var tbl = document.querySelector('table:not(.cart-drawer table)');
    if (!tbl) return;
    var ct = s('cancel_text', 'Cancel'),
      rt = s('reorder_text', 'Reorder');
    if (coc.page == 'account') {
      tbl.querySelector('thead tr')?.appendChild(document.createElement('th'));
      tbl.querySelector('tbody')?.querySelectorAll('tr').forEach((row, i) => {
        var div = document.createElement('div');
        div.className = 'coc-d-flex coc-flex-col coc-gap-2 coc-p-1';
        if (sc) div.appendChild(mkBtn('coc-cancel-button', ids[i], ct, true));
        if (sr) div.appendChild(mkBtn('coc-reorder-button', ids[i], rt, false));
        var td = document.createElement('td');
        td.appendChild(div);
        row.appendChild(td);
      });
    } else {
      var div = document.createElement('div');
      div.className = 'coc-d-flex coc-flex-wrap coc-gap-2 coc-py-2';
      if (sc) div.appendChild(mkBtn('coc-cancel-button', ids[0], ct, true));
      if (sr) div.appendChild(mkBtn('coc-reorder-button', ids[0], rt, false));
      tbl.parentNode?.insertBefore(div, tbl);
    }
  }

  function canCancel(id, cfg) {
    var o = (cfg || coc).orders[id];
    if (!o || o.cancelled || o.fulfillment != 'unfulfilled') return false;
    var max = parseFloat((cfg || coc)?.settings?.max_amount || -1);
    if (max > 0 && o.total_price > max * 100) return false;
    var av = {
      type: s('avail_type', 'until_ship'),
      value: s('avail_val', '1'),
      unit: s('avail_unit', 'days')
    };
    if (av.type === 'within') {
      var u = {
        minutes: 6e4,
        hours: 36e5,
        days: 864e5
      }[av.unit] || 6e4;
      if ((Date.now() - new Date(o.created_at)) / u > parseInt(av.value, 10)) return false;
    }
    return true;
  }

  function initButtons(cfg) {
    cfg = cfg || coc;
    Object.keys(cfg.orders).forEach(id => {
      var btn = document.querySelector(".coc-cancel-button[data-order-id='" + id + "']");
      if (!btn) return;
      var o = cfg.orders[id];
      if (canCancel(id, cfg)) {
        btn.innerHTML = s('cancel_text', 'Cancel');
        btn.disabled = false;
        btn.classList.add('coc-cancel-active');
      } else if (o.cancelled) {
        btn.innerHTML = s('cancelled_text', 'Cancelled');
        btn.disabled = true;
        btn.classList.add('coc-cancel-active');
      }
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!this.disabled && this.classList.contains('coc-cancel-active')) showCancelModal(this.getAttribute('data-order-id'));
      });
    });
    document.querySelectorAll('.coc-reorder-button').forEach(btn => {
      btn.innerHTML = s('reorder_text', 'Reorder');
      var id = btn.getAttribute('data-order-id') || 0,
        o = cfg.orders[id];
      if (o && o.line_items.split(',').every(i => i.split(':')[0] != '')) btn.classList.add('coc-reorder-active');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (this.disabled || coc.reordering) return;
        coc.reordering = true;
        this.innerHTML = s('reordering_text', 'Reordering...');
        var url = 'https://' + coc.shop + '/cart/' + coc.orders[id].line_items;
        if (s('reorder_destination', 'checkout') == 'cart') url += '?storefront=true';
        location.href = url;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    coc = window.coc_config || {};
    autoAddButton();
    if (document.querySelector('.coc-cancel-button,.coc-reorder-button')) initButtons();
  });

  // Expose only what's needed globally
  window.cocButtonEnable = () => initButtons(window.coc_config || {});
  window.coc_hideCancelModal = hideCancelModal;
  window.coc_handleCancelOrder = handleCancelOrder;

})();